module.exports = __webpack_public_path__ + "static/img/011.a3e4edf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/011.jpg
// module id = yiXu
// module chunks = 0